var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBadgedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.368,
    height: 28.368,
    viewBox: "0 0 28.368 28.368",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "scroll-outline-badged",
    transform: "translate(-2 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_654",
    "data-name": "Path 654",
    d: "M26.07,11.9a6.439,6.439,0,0,1-1.651-.224V25.686a2.149,2.149,0,0,1-2.149,2.149H9.083a3.843,3.843,0,0,0,.653-2.149V5.914a2.149,2.149,0,0,1,4.3,0v3.9h7.341A6.447,6.447,0,0,1,20.216,8.1H15.754V5.948A3.851,3.851,0,0,0,15.1,3.8h4.745a6.4,6.4,0,0,1,.739-1.719h-8.7A3.868,3.868,0,0,0,8.017,5.948V25.72a2.149,2.149,0,1,1-4.3,0V22.643H6.462V20.923H2v4.728A3.868,3.868,0,0,0,5.868,29.52h16.4a3.868,3.868,0,0,0,3.868-3.868V11.9Z",
    transform: "translate(0 -0.152)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_655",
    "data-name": "Path 655",
    d: "M33.6,5.3A4.3,4.3,0,1,1,29.3,1,4.3,4.3,0,0,1,33.6,5.3Z",
    transform: "translate(-3.228)",
    fill: "#666"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgedIcon);
export default __webpack_public_path__ + "static/media/badged-icon.dd2655adcd5a1f73199bf6286b93825e.svg";
export { ForwardRef as ReactComponent };